import moment from 'moment/moment';
import { IMG_PLACEHOLDER_PRODUCT, PROFILE_ORDERS_ITEM_LINK } from '../../../../assets/utils/constants';
import ImageWithBackground from '../../../ImageWithBackground/ImageWithBackground';
import './OrderCard.css';
import { parsePrice, parseStatus } from '../../../../assets/utils/utils';
import { Link } from 'react-router-dom';

// new: 'New',
// in_work: 'In Progress',
// paid: 'Paid',
// ready: 'Shipping',
// done: 'Completed',
// cancelled: 'Cancelled',
// refunded: 'Refunded',
// new_admin: 'New'

function OrderCard({ order }) {
    const FIRST_ITEM = order.order_items[0].item
    return (
        <Link
            to={`${PROFILE_ORDERS_ITEM_LINK}/${order._id}`}
            className='order-card'
        >
            < ImageWithBackground
                className={`order-card__image`}
                src={FIRST_ITEM.files && FIRST_ITEM.files.length > 0 ? FIRST_ITEM.files[0]?.urls.orig : IMG_PLACEHOLDER_PRODUCT}
                image_format={'10x16'}
                key={`${FIRST_ITEM.files && FIRST_ITEM.files.length > 0 ? FIRST_ITEM.files[0]?.urls.orig : IMG_PLACEHOLDER_PRODUCT}${FIRST_ITEM._id}`}
                metadata={FIRST_ITEM.files && FIRST_ITEM.files.length > 0 ? FIRST_ITEM.files[0]?.metadata : null}
            />
            <div className='order-card__info'>
                <p className='order-card__info-number'>№{order.ai_id}</p>
                <div className='order-card__info-date-price'>
                    <div className='order-card__info-date'>
                        <p className='order-card__info-date-title'>Date:</p>
                        <p className='order-card__info-date-value'>{moment(order.utc_date).format('DD.MM.YY')}</p>
                    </div>
                    <p className='order-card__info-price'>{parsePrice(order.total_price, 'USD')}</p>
                </div>
            </div>
            <p className={`order-card__status order-card__status_type_${order.status}`}>{parseStatus(order.status)}</p>
        </Link>
    );
}

export default OrderCard